export const useSiteDomain = (domain = '') => {
  const isRuDomain = domain.endsWith('.ru') || domain.endsWith('lmru.tech');
  const isKzDomain = domain.endsWith('.kz') || domain.endsWith('lmkz.tech');

  return {
    isKzDomain,
    isRuDomain,
  };
};
